import { Button } from '@chakra-ui/react'
import { Link } from 'react-router'
import { baseUrl } from '../../hooks'
import type { MenuItemProps } from './Menu'

export const MenuItem = ({
  children,
  to,
  variant,
  colorScheme,
  as,
  sx,
  ...rest
}: MenuItemProps) => {
  if (rest.href?.startsWith('/')) rest.href = baseUrl + rest.href

  return (
    <Button
      as={as ?? (rest.href ? 'a' : Link)}
      variant={variant || 'ghost'}
      colorScheme={colorScheme || 'primary'}
      to={to ?? ''}
      sx={{
        gap: 1,
        position: 'relative',
        justifyContent: 'start',
        textAlign: 'start',
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Button>
  )
}